import React, { useState, useEffect } from "react";
import ToolsComponent from "../../contents/ToolsComponent/ToolsComponent";
import TechstackComponent from "../../contents/TechstackComponent/TechstackComponent";
import "./Skills.css";

const Skills = () => {
  const [activeTab, setActiveTab] = useState("techstack");

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    const techstackList = document.querySelector(".skills-list");
    const skillList = document.querySelector(".tools-list");

    if (activeTab === "techstack") {
      techstackList.style.display = "block";
      skillList.style.display = "none";
    } else {
      techstackList.style.display = "none";
      skillList.style.display = "block";
    }
  }, [activeTab]);

  return (
    <>
      <section className="skills" id="skills">
        <div className="skills-content section-content">
          <p className="section-subtitle">My skills</p>

          <h2 className="h3 section-title">
            What My Programming Skills Included?
          </h2>

          <p className="section-text">
            I develop simple, intuitive and responsive user interface that helps
            users get things done with less effort and time with those
            technologies.
          </p>

          <div className="skills-toggle" data-toggle-box>
            <button
              className={`toggle-btn ${
                activeTab === "techstack" ? "active" : ""
              }`}
              onClick={() => toggleTab("techstack")}
              data-toggle-btn
              data-target="techstack"
            >
              Techstack
            </button>
            <button
              className={`toggle-btn ${activeTab === "skills" ? "active" : ""}`}
              onClick={() => toggleTab("skills")}
              data-toggle-btn
              data-target="skills"
            >
              Skills
            </button>
          </div>
        </div>

        <div className="skills-box" data-skills-box>
          <ul className="skills-list">
            <TechstackComponent />
          </ul>
          <ul className="tools-list">
            <ToolsComponent />
          </ul>
        </div>
      </section>
    </>
  );
};

export default Skills;
